import { Component, OnInit,ViewChild,TemplateRef,Input, group } from '@angular/core';
import { NgxPermissionsService } from 'ngx-permissions';
import {NgbModal, ModalDismissReasons,NgbModalRef} from '@ng-bootstrap/ng-bootstrap';

import { Router,ActivatedRoute } from '@angular/router';
import { HttpErrorResponse } from '@angular/common/http';
import { FileSelectDirective,FileUploader,FileItem, ParsedResponseHeaders } from 'ng2-file-upload';
import {Globals} from '../.././globals';
import { GroupService } from '../../service/group.service';
import { commonService } from '../../service/common.service';
@Component({
  selector: 'app-group',
  templateUrl: './group.component.html',
  styleUrls: ['./group.component.css'],
  providers:[GroupService]
})
export class GroupComponent implements OnInit {
  @ViewChild('group') public creategroup: TemplateRef<any>;
  modalReference:NgbModalRef;
  msg:any;
  isError=false;
  isSuccess=false;
  groupIcon ='';
  formvailidation=false;
  title:any;
  aboutGroup='';
  groupPrivacy='';
  groupRules='';
  groups:any;
  filterform:any;
  autoload:any;
  user:any;
  grouptitle:any;
  group:any;
  groupdetails:any;
  searchtxt:any;
  groupsLoder=true;
  isclickbutton=false;
  passcode:string;
  ispasscode=false;
  currentEditObj:any;
  ismygroup=false;
  createdGroup:any=[];
  

  readonly rootUrl = this.global.siteUrl;
  readonly profileUrl  =  this.global.profileUrl;
  url =this.rootUrl+'file/upload?folder='+this.global.groupProfileFolder;
  path=this.global.groupProfileUrl;
  @Input() fileExt: string = "";
  errors: Array<string> =[];
  fileExtExists=false;
  uploader:FileUploader=new FileUploader({url:this.url,authToken:localStorage.getItem('_to'),maxFileSize: 20000000 ,allowedMimeType: ['image/png','image/jpeg','image/jpg']});
  attactmentlist:number;
  Group={'title':'Groups','desciprtion':'desciprtion'};
  groupObj:any;
  

  constructor(private _common:commonService,private modalService: NgbModal,private global:Globals,private _group:GroupService,private router:Router) { 

    this.uploader.onErrorItem = (item, response, status, headers) => this.onErrorItem(item, response, status, headers);
    this.uploader.onSuccessItem = (item, response, status, headers) => this.onSuccessItem(item, response, status, headers);
    this.uploader.clearQueue = ()=>this.clearQueue();
    this.uploader.onWhenAddingFileFailed = (fileItem) => {
      this.msg="File size must 20mb or below.";
      this.isError = true;
      this.isSuccess = false;
    }
    this.group= {};
  }

  ngOnInit() {
    // get user details
  this._common.profile.subscribe((data:any)=>{
    if(data){
    this.user = data;
    this.getUserGroup();
    }else{
    this.user={};
    this.getUserGroup();
    }
    })
   
  }

  getUserGroup(){
    
    this._group.getUserGroup({userId:(this.user?this.user.id:0),ismygroup:this.ismygroup}).subscribe((data : any)=>{
      if(data.error==0){ 
        this.groupsLoder=false;
       this.groups=  data.results;
      }else{
        if(data.message=="Failed to authenticate token."){
          this.router.navigate(['/']);
        }else{
        this.msg = data.message;
        this.isError = true;
        this.isSuccess = false;
        }
      }
  },
      (error : HttpErrorResponse)=>{
        this.isError = true;
        this.msg="internal server error!";
      });
  
  } 
  
  openGroupForm(content,action){


    this._group.getGroupByUser({userId:(this.user?this.user.id:0)}).subscribe((data : any)=>{
      if(data.error==0){ 

        this.createdGroup  = data.results;
       // this.groupsLoder=false;
      // this.groups=  data.results;
      // console.log('11111111111111111');
      // console.log(data.results);

      }else{


      }
    }
    )
    //let localmodalReference=this.modalReference;
    this.grouptitle=action;
    this.groupIcon =this.path+'/grouplogo.svg';
    this.clearQueue()
    // form filed blank
    this.group='';
    this.title='';
    this.aboutGroup='';
    this.groupPrivacy='';
    this.groupRules=''
    if(content != null){
      this.modalReference =  this.modalService.open(content,{size: 'lg',backdrop : 'static',
      keyboard : false }); 
    }
  }



  onFileChanged($event){
     this.uploader.uploadAll();
   }

   /****file uploder responce***/
onSuccessItem(item: FileItem, response: string, status: number, headers: ParsedResponseHeaders): any {
  let data = JSON.parse(response); //success server response
//console.log(data);

    if(data.error==0){
      this.groupIcon  = this.path+'/'+data.result.mediaDetail.uploadname
     this.attactmentlist=data.result.id;
    }


 
   
}

onErrorItem(item: FileItem, response: string, status: number, headers: ParsedResponseHeaders): any {
    let error = JSON.parse(response); //error server response
    
}  


ngAfterViewInit() {
  this.uploader.onAfterAddingFile = (item => {
     item.withCredentials = false;
  });
 }

 clearQueue() {
  this.uploader.queue = [];
  this.attactmentlist=0;
 }
/****file uploder responce***/

addGroup(formData){
  if(formData.status=="INVALID"){
    this.formvailidation=true;
   }else{
     this.isclickbutton=true;
    this.formvailidation=false;
    formData.value['logo']  =  this.attactmentlist;
    formData.value['action']  = this.grouptitle;
    formData.value['userType']  = this.user.userType;
    formData.value['createdby']  = this.user.id;
    formData.value['passCode'] =this.passcode;
   
    this._group.addGroup(formData.value).subscribe((data : any)=>{
    if(data.error==0){ 
      this.isclickbutton=false;
      this.modalReference.close();
        if(this.grouptitle=="Create"){
        
         this.router.navigate(['/groups/'+encodeURIComponent(btoa(data.group))])
        }else{
          this.modalReference.close();
          if(this.grouptitle!="Update"){
          alert("This Group is pending approval, It will start to appear in the Groups once it gets approved by the Moderator.");
          }else{
            this.router.navigate(['/groups/'+encodeURIComponent(btoa(data.group))])
          }
          
          //this.isError = false;
          //this.isSuccess = true;

        }
   
    }else{
      this.isclickbutton=false;
      if(data.message=="Failed to authenticate token."){
        this.router.navigate(['/']);
      }else{
      this.msg = data.message;
      this.isError = true;
      this.isSuccess = false;
      }
    }
},
    (error : HttpErrorResponse)=>{
      this.isError = true;
      this.msg="internal server error!";
    });

} 

}

groupsdetails(id){
  if(Object.keys(this.user).length == 0){ 
    this.needLogin();
    return false;
  } 

  this.router.navigate(['/groups/'+encodeURIComponent(btoa(id))])
}
needLogin(){
  this._common.setLoginBox(true);        
}

delcontent(event,index){

if(confirm('Do you want to delete?')){
  this._group.delgroup({"group":encodeURIComponent(btoa(event.id))}).subscribe((data:any)=>{
    if(data.error==0){ 
        this.groups.splice(index, 1);
    }else{
      if(data.message=="Failed to authenticate token."){
        this.router.navigate(['/']);
      }else{
      //this.msg = data.message;
     // this.isError = true;
     // this.isSuccess = false;
      }
    }
},
    (error : HttpErrorResponse)=>{
    //  this.isError = true;
      //this.msg="internal server error!";
    });
}

}

editcontent(obj,index,content){
  //console.log(obj);

  this.grouptitle="Update";
  this.passcode='';
  this.currentEditObj = obj;
 
  if(obj.logo==""){
  this.groupIcon =this.path+'/grouplogo.svg';
  }else{
    this.groupIcon= this.path+obj.logo;
  }
  this.clearQueue()
  this.group=encodeURIComponent(btoa(obj.id));
  this.title=obj.title;
  this.aboutGroup=obj.aboutGroup;
  this.groupPrivacy=obj.groupPrivacy;
  this.groupRules=obj.groupRules;
  if(this.groupPrivacy=='Private'){
         this.ispasscode=true;
         //this.passcode=obj.passCode;
  }else{
    this.ispasscode=false;
    
  }
  this.modalReference =  this.modalService.open(content,{size: 'lg',backdrop : 'static',
    keyboard : false }); 
    this._group.getGroupByUser({userId:(this.user?this.user.id:0),group:this.group}).subscribe((data : any)=>{
      if(data.error==0){ 
        this.createdGroup  = data.results;
      } 
      })
    this.grouptitle="Update";
}


filteruser(search){

 // console.log(search);
 var searchtxt  = search.trim();
 if(searchtxt!=""){ 
       this._group.filtergroup({"search":searchtxt,"userId":(this.user?this.user.id:0)}).subscribe((data:any)=>{
       if(data.error==0){ 
   
        this.groupdetails = data.results.rows;

       }else{
         if(data.message=="Failed to authenticate token."){
           this.router.navigate(['/']);
         }else{
         }
         }
     },
         (error : HttpErrorResponse)=>{
         //  this.isError = true;
           //this.msg="internal server error!";
         });
 }else{
   this.groupdetails=[];
 }
}

putdata(objData,event){

  this.searchtxt =event.target.innerHTML; 
  this.groupdetails=[];
  this._group.getUserGroup({group:objData.id,userId:(this.user?this.user.id:0)}).subscribe((data : any)=>{
    if(data.error==0){ 
     this.groups=  data.results;
    }else{
      if(data.message=="Failed to authenticate token."){
        this.router.navigate(['/']);
      }else{
      this.msg = data.message;
      this.isError = true;
      this.isSuccess = false;
      }
    }
},
    (error : HttpErrorResponse)=>{
      this.isError = true;
      this.msg="internal server error!";
    });
}

genratepasscode(){
  this.passcode = Math.random().toString(36).substring(2,8).toUpperCase();
}
getgroupPrivacy(event){
  if(event=='Private'){
    this.ispasscode=true;
  }else{
    this.ispasscode=false;
    this.passcode='';
  }
}

regeneratepasscode(group){
  let obj={};
  obj['groupId']=group.id;
  obj['passCode']=Math.random().toString(36).substring(2,8).toUpperCase();
  group.isclickbutton=true;
  this._group.regeneratepasscode(obj).subscribe(
    (data: any) => {
      group.isclickbutton=false;
      if(data.error == 0) {
          group.passCode  = data.results.passCode;
          group.passCodeExpiryDate  = data.results.passCodeExpiryDate;
      }else{
        alert(data.message);
      }
    })
}

mygroup(){
  this.groupsLoder=true;
  this.ismygroup=true;
  this.getUserGroup();
}


allgroup(){
  this.groupsLoder=true;
  this.ismygroup=false;
  this.getUserGroup();
}


customdecode(data){   
  return encodeURI(btoa(data));
 }

}



// WEBPACK FOOTER //
// C:/projects/wct-nextias-ui/src/app/home/group/group.component.ts